export default "__VITE_ASSET__C42_tUDO__"